export enum Type {
    restaurant = "Restaurante",
    bar = "Bar",
    party = "Fiesta",
    brunch = "Desayuno/Almuerzo/Postres",
    hotel = "Hotel",
    activity = "Actividad",
    public_place = "Lugar público",
}
